.input {
  min-height: 6.4rem;
  background-color: transparent;
  outline: none;
  flex: 1;
  width: 100%;
  color: var(--color-grayscale-white);
  font-family: Inter, sans-serif;
  font-size: 1.4rem;
  resize: vertical;
  border: none;

  p {
    font-size: 1.4rem;
  }
}
